export default __webpack_public_path__ + "static/media/matterbase_logo_mobile.08528045.svg";